import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { library } from './store/useLibrary';
import { applyTheme } from './theme/useTheme';
import { seedCells } from './domain/seed';

/** One-time migration of the legacy build-free app's localStorage library. */
async function importLegacy() {
  try {
    const raw = localStorage.getItem('skein:v2') || localStorage.getItem('skein:v1');
    if (!raw) return;
    const data = JSON.parse(raw);
    const patterns = data?.patterns ? Object.values(data.patterns) : [];
    for (const p of patterns) await library.create(p as Parameters<typeof library.create>[0]);
    if (data?.settings?.theme) await library.setSetting('theme', data.settings.theme);
    localStorage.setItem('skein:migrated', '1');
    localStorage.removeItem('skein:v2');
  } catch {
    /* ignore malformed legacy data */
  }
}

async function bootstrap() {
  await library.init();
  // Migrate legacy localStorage data once, before seeding.
  if (library.list().length === 0 && !localStorage.getItem('skein:migrated')) await importLegacy();
  applyTheme(library.getSettings().theme);
  // First run: seed a welcome pattern so the studio isn't empty.
  if (library.list().length === 0) {
    await library.create({
      name: 'Welcome sampler',
      description: 'A starter colourwork motif. Edit it, or make a new pattern from the library.',
      fields: { tags: 'sample' },
      cols: 25,
      rows: 25,
      gauge: 'dk',
      cells: seedCells(25, 25),
    });
  }
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>
  );
}

void bootstrap();
